import { render, staticRenderFns } from "./FtaBottomDateInfo.vue?vue&type=template&id=75a336b5&scoped=true"
import script from "./FtaBottomDateInfo.vue?vue&type=script&lang=js"
export * from "./FtaBottomDateInfo.vue?vue&type=script&lang=js"
import style0 from "./FtaBottomDateInfo.vue?vue&type=style&index=0&id=75a336b5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a336b5",
  null
  
)

export default component.exports